export const ICON_BOXES = {
  sm: {
    width: 24,
    height: 24,
  },

  md: {
    width: 32,
    height: 32,
  },

  lg: {
    width: 40,
    height: 40,
  },
};
export const ICON_SIZES = {
  sm: 20,
  md: 28,
  lg: 36,
};